// extracted by mini-css-extract-plugin
module.exports = {"skeleton-placeholder":"skeleton-place-holder_skeleton-placeholder__EiPxa","skeletonAnimation":"skeleton-place-holder_skeletonAnimation__M_Dcf"};